import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { isRoamSource } from '../utils';

/**
 * Displays stats about saved items and search results
 */
const SearchStatsBar = ({
  allTweets,
  filteredTweets,
  filteredCount,
  searchTerm,
  displayQuery
}) => {
  const [showBreakdown, setShowBreakdown] = useState(false);

  // Determine which tweets to count: filtered results when searching, all tweets otherwise
  const tweetsToCount = searchTerm ? filteredTweets : allTweets;

  // Count items by source type
  const likeCount = tweetsToCount.filter(t => t.source === 'like').length;
  const bookmarkCount = tweetsToCount.filter(t => t.source === 'bookmark').length;
  const userTweetCount = tweetsToCount.filter(t => t.source === 'user_tweet').length;
  const redditCount = tweetsToCount.filter(t => t.source === 'reddit').length;
  const roamCount = tweetsToCount.filter(t => isRoamSource(t.source)).length;

  return (
    <>
      <p className="mb-4 subtitle">
        Explore & rediscover my liked and bookmarked tweets, saved roam quotes, and Reddit saves!
      </p>
      
      <div className="mb-4">
        <button
          onClick={() => setShowBreakdown(!showBreakdown)}
          className="total-tweets text-left hover:text-blue-600 dark:hover:text-blue-400 transition-colors flex items-center"
        >
          {searchTerm && (
              <span className="mr-4 subtitle">
                Found {filteredCount} results for "{displayQuery}"
              </span>
            )}
          <span>
            Total saved items: <span className="font-italic">{allTweets.length}</span>
          </span>
          <ChevronDown 
            className={`h-4 w-4 ml-2 transition-transform ${showBreakdown ? 'rotate-180' : ''}`}
          />
          
        </button>
        
        {showBreakdown && (
          <div className="mt-2 p-3 bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 animate-fadeIn">
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 text-sm">
              <div className="text-center">
                <div className="font-medium text-blue-600 dark:text-blue-400">{likeCount}</div>
                <div className="text-xs text-gray-500 dark:text-gray-400">Likes</div>
              </div>
              <div className="text-center">
                <div className="font-medium text-green-600 dark:text-green-400">{bookmarkCount}</div>
                <div className="text-xs text-gray-500 dark:text-gray-400">Bookmarks</div>
              </div>
              <div className="text-center">
                <div className="font-medium text-purple-600 dark:text-purple-400">{userTweetCount}</div>
                <div className="text-xs text-gray-500 dark:text-gray-400">User Tweets</div>
              </div>
              <div className="text-center">
                <div className="font-medium text-orange-600 dark:text-orange-400">{redditCount}</div>
                <div className="text-xs text-gray-500 dark:text-gray-400">Reddit</div>
              </div>
              <div className="text-center">
                <div className="font-medium text-indigo-600 dark:text-indigo-400">{roamCount}</div>
                <div className="text-xs text-gray-500 dark:text-gray-400">Roam</div>
              </div>
            </div>
          </div>
        )}
      </div>
      
    </>
  );
};

export default SearchStatsBar;